import { render, staticRenderFns } from "./EventDetailsRoom.vue?vue&type=template&id=1fa9a1f0"
import script from "./EventDetailsRoom.vue?vue&type=script&lang=js"
export * from "./EventDetailsRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports